export const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/range.js